import React, { Component } from 'react';
import NavBar from '../navBar/NavBar';
import Footer from '../footer/Footer';
import LandingSection from './landing/Landing';
import ProjectsList from './projectsList/ProjectsList';
import ScrollToTopOnMount from '../ScrollToTop';

import { trackPage } from '../helpers/AnalyticsManager';

class Portfolio extends Component {
  constructor() {
    super();

    trackPage('Portfolio');
  }

  render() {
    return (
      <div className="Portfolio">
        <ScrollToTopOnMount />
        <NavBar darkMode />
        <LandingSection />
        <ProjectsList />
        <Footer target="industry" language="english" />
      </div>
    );
  }
}
export default Portfolio;
